module.exports = __webpack_public_path__ + "static/img/huaxiafenmo.5945f84d.png";